import React from 'react';

const ConfirmModal = ({ state, onClose }) => {
    if (!state?.open) return null;

    return (
        <div className="modal-overlay" onClick={() => onClose(false)}>
            <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '560px' }}>
                <h3 style={{ marginTop: 0 }}>{state.title || 'Confirm'}</h3>
                <p className="subtitle" style={{ whiteSpace: 'pre-wrap' }}>
                    {state.message}
                </p>
                <div className="modal-footer">
                    <button className="btn btn-outline" onClick={() => onClose(false)}>
                        {state.cancelText || 'Cancel'}
                    </button>
                    <button className={`btn ${state.danger ? 'btn-danger' : 'btn-primary'}`} onClick={() => onClose(true)}>
                        {state.confirmText || 'Confirm'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
